/**
   *  Loại phương án phân bổ
   */
export default {
  DeliverBeginYear: 1, //Giao đầu năm
  DeliverAdditionalAdjustment: 5 //Giao bổ sung, điều chỉnh
};